module.exports = __webpack_public_path__ + "static/media/page6.2777db8a.png";